export default class LocalizedText {
    constructor(id = '') {
        this.id = null;
        this.text = "";
        this.language = "";
        this.id = id;
    }
}
